<template>
    <div class="Home-container">
        <div class="common-layout">
            <pageHeader />
            <div style="padding-top: 20px;;">
                <el-container>
                    <el-container>
                        <el-aside width="500px">
                            <div>
                                <NewCount></NewCount>
                            </div>
                            <div style="padding-top: 20px;">
                                <NewTip></NewTip>
                            </div>
                            <div style="padding-top: 20px;">
                                <Newhot></Newhot>
                            </div>
                        </el-aside>
                        <el-main>
                            <DeviceList @change="changeCarousel">
                            </DeviceList>
                        </el-main>
                    </el-container>
                </el-container>
            </div>
        </div>
    </div>
</template>

<script>
    import pageHeader from './components/header.vue'
    import monitor from './components/monitor/index.vue'
    import count from './components/count/index.vue'
    import heatingSystemWarning from './components/heating-system-warning/index.vue'
    import electricalWarning from './components/electrical-warning/index.vue'
    import maintenanceTips from './components/maintenance-tips/index.vue'
    import heatingStatistics from './components/heating-statistics/index.vue'
    import waterConsumptionStatistics from './components/water-consumption-statistics/index.vue'
    import userStatistics from './components/user-statistics/index.vue'


    import NewCount from './c/count.vue'
    import NewTip from './c/tip.vue'
    import Newhot from './c/hot'
    import DeviceList from './c/device-list.vue'
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        components: {
            DeviceList,
            Newhot,
            NewTip,
            NewCount,
            pageHeader,
        },
        inject: ['app'],
        data() {
            return {
                carouselUpdate: 0,
                timer: null,
                offset: 0
            }
        },
        watch: {
            '$route'(n) {
                if (n && n.name !== 'Common.Home') {
                    // 离开页面
                    clearInterval(this.timer)
                }
            }
        },
        methods: {
            changeCarousel(e) {
                console.log('changeCarousel', e)
                this.carouselIndex = e
            },
        },
        mounted() {
            setInterval(() => {
                this.offset = this.Data.offset
                if (this.Data.device_total > this.offset) {
                    this.$Bus.emit('index', {
                        showToast: false,
                        offset: this.offset,
                        OpenLoading: false,
                    })
                    this.carouselUpdate = new Date().getTime()
                }
            }, 1000 * 15)

            this.$Bus.emit('index', {
                showToast: true
            })
            // 一小时刷新一次
            this.timer = setInterval(() => {
                // this.offset = 0
                // this.$Bus.emit('index', {
                // 	showToast: true,
                // 	offset: this.offset,
                // 	OpenLoading: true,
                // })
                location.reload()
            }, 1000 * 60 * 60)
        }
    }
</script>

<style lang="less" scoped>
    .Home-container {
        position: relative;
        box-sizing: border-box;
        margin: 0 auto;
        padding: 0 32px 32px;
        width: 1920px;

        .s-b {
            display: flex;
            justify-content: space-between;
        }

        .left-form-warp {
            width: 1227px;
        }

        .right-form-warp {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }
    }
</style>
